
import React, { useEffect, useState } from 'react';
import { formatIndianCurrency } from '../../../helper/ConvertValue'
import { CheckSign } from "../../../helper/ConvertValue"
import ErrorIcon from "@mui/icons-material/Error";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CommonToolTip from '../../Common/CommonToolTip';


import cashFlowTablecss from "../../../myfin_v2/css/cashFlowTable.module.css";
import tablecss from "../../../myfin_v2/css/table.module.css";

import loanCss from "../../../myfin_v2/css/overview.module.css"
import {ReactComponent as Plus} from "../../../myfin_v2/assets/icons/plusBlack.svg"
import { cashflowAddNewLineItem } from '../../../services/api/apiHandler';
import swal from 'sweetalert';
import { toast } from "react-toastify";


const CashFlowWorkingTable = ({ HandleChange, index, HandleSelect, workingOpt ,allData,AddNewLineItem}) => {
    const user = JSON.parse(localStorage.getItem('user'));
//   console.log('HandleAddNewLineItem prop:', HandleAddNewLine);
  console.log('AddNewLineItem prop:', AddNewLineItem);
    //  const [cashFlowWorking, setCashFlowWorking] = useState([]);
    //   const project_id = localStorage.getItem('project_id');
    // const tb_id = localStorage.getItem('tb_id');
    //  const [faceValueData, setFaceValueData] = useState([]);
    //  const AddNewLineItem = (index) => {
    //     console.log("index",index);
    //         if(user.responsibilities === "view"||user.responsibilities === "approver"){
    //             swal("Warning","You Don't have access to add newLine items","warning");
    //             return false;
    //         }
    //         cashflowAddNewLineItem({project_id, index}).then(response => {
    //             toast.success(response.data?.message || "New Item Added Successfully");
    //             setCashFlowWorking(response.data?.workingData)
    //             setFaceValueData(response.data?.fvData)
    //         }).catch(error => {
    //             swal("Error", error, "error");
    //         });
    //     }

    const CheckSignReturn = (n1, n2, keyI, i) => {
        let cy = CheckSign(n1)
        let py = CheckSign(n2)

        if (keyI === 3 && i === 6) {
            return cy === false || py === false ? true : false
        }
        if ([4, 5].includes(keyI) && i === 2) {
            return cy === false || py === false ? true : false
        }

        if ([0, 3].includes(keyI)) {
            if ([1, 7].includes(i)) {
                //  -ve
                return cy === true || py === true ? true : false
            } else if ([3, 5, 8, 10].includes(i)) {
                // +ve
                return cy === false || py === false ? true : false
            } else {
                return false
            }
        } else if ([1, 2, 4, 5].includes(keyI)) {
            if ([1, 5].includes(i)) {
                // -ve
                return cy === true || py === true ? true : false
            } else if ([3, 6, 8].includes(i)) {
                // +ve
                return cy === false || py === false ? true : false
            } else {
                return false
            }
        } else if ([6].includes(keyI)) {
            if ([1].includes(i)) {
                // -ve
                return cy === true || py === true ? true : false
            } else if ([2, 3].includes(i)) {
                // +ve
                return cy === false || py === false ? true : false
            } else {
                return false
            }
        } else if (keyI === 21) {
            if ([2, 3].includes(i)) {
                // -ve
                return cy === true || py === true ? true : false
            } else {
                return false
            }
        } else if (keyI === 22) {
            if (i === 3) {
                // -ve
                return cy === true || py === true ? true : false
            } else if (i === 2) {
                // +ve
                return cy === false || py === false ? true : false
            } else {
                return false
            }
        } else if (keyI === 23) {
            if ([2, 3].includes(i)) {
                // -ve
                return cy === true || py === true ? true : false
            } else {
                return false
            }
        }
    }

    const RenderOptions = (element) => {
        const subData = workingOpt.find(ele => ele?.faceValue === element?.adjustmentCashFlowStatement)?.subData || [];
        return subData.map((option, index) => 
            <option className='text-secondary' key={index} value={option.value}>{option.name}</option>
        )
    }
    

    return (
        <>
            {/* <table className='bg-white' > */}
             <table   className={`${cashFlowTablecss.bookClosureTable} ${tablecss.brTable}`} style={{ marginBottom: "2rem" }}>
              
                <thead >
                    <tr className={`bg-white ${cashFlowTablecss.tableHeaderFixed}`}>
                        {/* <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' style={{ minWidth: "50px" }}>S.no</th> */}
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' >Adjustments Name</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left'>Current Year</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left'>Previous Year</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' >Adjustment in Cash flow statement</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left'>Amount to be reflected in Cash Flow (CY)</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left'>Amount to be reflected in Cash Flow (PY)</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' >Name of the item in cash flow statement</th>
                        {/*  <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' >Internal formula reference (inside cash flow)</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' >Nature of Adjustment</th>*/}
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' style={{ minWidth: "250px" }}>Remarks</th>
                        <th className='font-size-12 border-top-0 border-bottom-0 custom-font-600 text-left' style={{ minWidth: "50px" }}></th>
                    </tr>
                    {/* <tr>
                         <td colspan="12"style={{ backgroundColor: "#eff7f0" }}  >{ele.name}</td>
                    </tr> */}
                </thead>
                
                <tbody>
                     
                    {
                        // data && data.length > 0 && data.map((ele, i) => (
                            allData && allData.map((ele, index) => (

                                <React.Fragment key={ele.workingId}>
                        <tr>
                            <td colSpan="12" className={cashFlowTablecss.tableHeaderHighlited} >{ele.name}</td>
                        </tr>
                        {ele.data && ele.data.map((ele, i) => (
                            <tr key={i} className={ele.isColored ? `${cashFlowTablecss.greyTableRowElement}` : ""}>
                                {/* <td className={`text-left pl-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ? "custom-bg-gray-200" : ""}`}>{i + 1}</td> */}
                                <td className={`text-left pl-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>
                                    {ele?.isAdjustmentName ? 
                                        <textarea 
                                            value={ele?.adjustmentsName}
                                            name='adjustmentsName'
                                            className='h-100 w-100 border-0 bg-color-inherit text-secondary'
                                            onChange={(e) => HandleSelect(e, index, i)}
                                        />
                                    : ele?.adjustmentsName}
                                </td>
                                <td className={`border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>{ele?.manualCy ?
                                    <input
                                        name='cy'
                                        type='text'
                                        disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                                        value={formatIndianCurrency(ele?.cy)}
                                        className='w-100 h-100 text-right pr-3 mt-0 border-0 bg-light font-size-14 '
                                        onChange={(e) => HandleChange(i, e)}
                                    />
                                    :
                                    <div className='text-right pr-3'> {formatIndianCurrency(ele?.cy)} </div>
                                }
                                </td>
                                <td className={`border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`} >{
                                    ele?.manualPy ?
                                        <input
                                            name='py'
                                            type='text'
                                            disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                                            value={formatIndianCurrency(ele?.py)}
                                            className='w-100 h-100 text-right pr-3 mt-0 border-0 font-size-14  bg-light'
                                            onChange={(e) => HandleChange(i, e)}
                                        /> :
                                        <div className='text-right pr-3'> {formatIndianCurrency(ele?.py)} </div>
                                }</td>

                                <td className={`text-left pl-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>
                                    {
                                        ele?.isAdjustmentCashFlowStatement ? (
                                            <select 
                                                className='h-100 w-100 border-0 bg-color-inherit text-secondary' 
                                                name='adjustmentCashFlowStatement'
                                                value={ele?.adjustmentCashFlowStatement || ""}
                                                onChange={(e) => HandleSelect(e, index, i)} 
                                            >
                                                <option value="select">Select</option>
                                                {
                                                    workingOpt?.length > 0 && workingOpt.map((option, index) => 
                                                        <option key={index} value={option.faceValue}>{option.name}</option>
                                                    )
                                                }
                                                {/* <option 
                                                    className='cursor-pointer custom-common-theme-text-color text-center'
                                                    value="add-new-option"
                                                >
                                                    Add New Option +
                                                </option> */}
                                            </select>
                                        ) : ele?.adjustmentCashFlowStatement
                                    }
                                </td>

                                <td className={`text-right pr-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>{formatIndianCurrency(ele?.cy_amount)}</td>
                                <td className={`text-right pr-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>{formatIndianCurrency(ele?.py_amount)}</td>

                                <td className={`text-left pl-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>
                                    { 
                                        ele?.isNameOfItemCashFlowStatement ? (
                                            <select 
                                                className='h-100 w-100 border-0 bg-color-inherit text-secondary' 
                                                name='nameOfItemCashFlowStatement'
                                                value={ele?.nameOfItemCashFlowStatement || ""}
                                                onChange={(e) => HandleSelect(e, index, i)} 
                                            >
                                                <option value="select" className='text-secondary'>Select</option>
                                                { RenderOptions(ele) }
                                                <option 
                                                    className='cursor-pointer custom-common-theme-text-color text-center'
                                                    value="add-new-option"
                                                >
                                                    Add New Option +
                                                </option>
                                            </select>
                                        ) :
                                        ele?.nameOfItemCashFlowStatement &&
                                        ele?.nameOfItemCashFlowStatement.length > 25 ? (
                                            <div className="rtooltip font-sans cursor-pointer" >{ele?.nameOfItemCashFlowStatement.substring(0, 25).concat('...')}
                                                <span className="rtooltiptext font-sans">{ele?.nameOfItemCashFlowStatement}</span>
                                            </div>
                                        ) : ele?.nameOfItemCashFlowStatement
                                    }
                                </td>
                                {/* <td className={`text-center border-top-0 border-bottom-0 font-size-14  ${ele.isColored ? "custom-bg-gray-200" : ""}`}>
                                        <CommonToolTip variant="primary" placement="top" title={ele?.internalFormulaReference}>
                                            <VisibilityIcon style={{ cursor:"pointer" }} />
                                        </CommonToolTip>
                                    </td>
                                */}
                                {/* <td className={`text-left pl-3 border-top-0 border-bottom-0 font-size-14  ${ele.isColored ? "custom-bg-gray-200" : ""}`}>{ele?.natureOfAdjustment}</td> */}
                                <td className={`border-top-0 border-bottom-0 font-size-14  ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>
                                    <textarea
                                        className='w-100 p-1 border-0 bg-color-inherit text-secondary'
                                        value={ele?.remarks}
                                        disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                                        name='remarks'
                                        onChange={(e) => HandleSelect(e, index, i)}
                                    />
                                </td>
                                <td className={`border-top-0 border-bottom-0 ${ele.isColored ?  `${cashFlowTablecss.greyTableRowElement}` : ""}`}>
                                    {
                                        CheckSignReturn(ele?.cy, ele?.py, index, i) &&
                                        <CommonToolTip
                                            variant="primary"
                                            title={"Value sign not matched."}
                                            placement="top"
                                        >
                                            <ErrorIcon
                                                style={{
                                                    color: "darkorange",
                                                    cursor: "pointer",
                                                }}
                                                className="financialInstrument-hoverIcon"
                                            />
                                        </CommonToolTip>
                                    }
                                </td>
                            </tr>
                            
                            
                             ))}
                        <tr>
                            <td colSpan="12" style={{ backgroundColor: "#ffffffff", padding: "0px" }}> 
                                        <button 
                                            className={`${tablecss.addNewLineItem}`}
                                            onClick={() => {
                                                console.log(`clicked on add new line item at index ${index}`);
                                                // HandleAddNewLine(index);
                                                AddNewLineItem(index);
                                            }}
                                            
                                        >
                                             <Plus className={`${loanCss.plusIcon}`} />
                                            New Line Item 
                                        </button>
                                       
                            </td>
                        </tr>
                    </React.Fragment>
                        ))
                    }
                </tbody>
            </table>
        </>
    )
}

export default CashFlowWorkingTable